
/* eslint-disable vue/no-mutating-props */
import configCard from './config-card.vue';
import { categories } from '@/common/material-metadata';
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';

export default {
  components: {
    configCard: configCard
  },
  props: {
    formConfig: {
      type: Object,
      required: true
    },
    schemeValue: {
      type: Object,
      default: function _default() {}
    },
    demand: {
      type: Object,
      default: function _default() {}
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      formValue: {
        category_id: '',
        category_text: ''
      }
    };
  },

  computed: {
    formItemList: function formItemList() {
      var list = [{
        visible: !this.readOnly,
        label: '素材类型：',
        type: 'select',
        prop: 'category_id',
        rules: [{
          required: true,
          message: '请选择素材类型',
          trigger: 'change'
        }],
        params: {
          style: 'width:400px',
          disabled: !!this.schemeValue.creative_id || !!this.schemeValue.category_id && this.demand.material_source === 3,
          options: categories,
          clearable: true,
          placeholder: '请选择素材类别'
        }
      }, {
        visible: this.readOnly,
        label: '素材类型：',
        type: 'plain-text',
        prop: 'category_text'
      }];
      return list;
    },
    creationType: function creationType() {
      try {
        // 1: playable, 2: endcard
        return this.demand.creation_tasks[0].creation_type;
      } catch (error) {
        return 0;
      }
    }
  },
  watch: {
    'formValue.category_id': function formValueCategory_id(val) {
      this.schemeValue.category_id = val;
    },
    'schemeValue.fetch_data': function schemeValueFetch_data(val) {
      if (val) {
        this.fillForm();
      }
    },
    'schemeValue.category_id': function schemeValueCategory_id(val) {
      if (val !== this.formValue.category_id) {
        this.fillForm();
      }
    }
  },
  methods: {
    validate: function validate(cb) {
      return this.$refs.form.validate(cb);
    },
    fillForm: function fillForm() {
      if (this.schemeValue.category_id) {
        this.formValue.category_id = this.schemeValue.category_id;
        this.formValue.category_text = useValueExchangeLabel(this.schemeValue.category_id, categories);
      }
    }
  },
  mounted: function mounted() {
    this.fillForm();
  }
};